module.exports = __webpack_public_path__ + "img/流体力学4_5_3.d6692a85.jpg";